module.exports = require("/codebuild/output/src694322608/src/pedro-site/src/utils/typography.js")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 372
// module chunks = 231608221292675